import {Map, fromJS, List} from "immutable";

import {FETCH_DELIVERY_NOTES_REQUEST, FETCH_DELIVERY_NOTES_SUCCESS, FETCH_DELIVERY_NOTES_ERROR, CLEAN_DELIVERY_NOTES_STATE} from "./delivery-notes-actions"

const deliveryNotes = (state = Map({
    payload: List([]),
    isFetching: false,
    error: false
}), action) => {
    let newState;
    switch (action.type) {

        // Requests
        case FETCH_DELIVERY_NOTES_REQUEST:
            newState = state.merge({
                isFetching: true,
                error: false
            });
            return newState;

        // Success
        case FETCH_DELIVERY_NOTES_SUCCESS:
            newState = state.merge({
                payload: fromJS(action.payload),
                isFetching: false,
                error: false
            });
            return newState;

        // Errors
        case FETCH_DELIVERY_NOTES_ERROR:
            newState = state.merge({
                isFetching: false,
                error: action.error,
                errorMessage: action.errorMessage
            });
            return newState;

        // Clean state
        case CLEAN_DELIVERY_NOTES_STATE:
            newState = state.merge({
                payload: undefined,
                isFetching: false,
                error: false
            });
            return newState;

        default:
            return state;
    }
};

export default deliveryNotes;